import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  title?: string;
  className?: string;
  footer?: ReactNode;
  bordered?: boolean;
  shadow?: boolean;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  title,
  className = '',
  footer,
  bordered = true,
  shadow = true,
  onClick,
}) => {
  const borderClass = bordered ? 'border border-gray-200' : '';
  const shadowClass = shadow ? 'shadow-md' : '';

  return (
    <div
      className={`bg-white rounded-lg overflow-hidden ${borderClass} ${shadowClass} ${className} ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      {title && (
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        </div>
      )}
      <div className="px-6 py-4">{children}</div>
      {footer && <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">{footer}</div>}
    </div>
  );
};

export default Card;
